webpackJsonp([72219630427739],{

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.wisconsinImageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _HeroSmall = __webpack_require__(8);
	
	var _HeroSmall2 = _interopRequireDefault(_HeroSmall);
	
	var _LocationMicroNav = __webpack_require__(10);
	
	var _LocationMicroNav2 = _interopRequireDefault(_LocationMicroNav);
	
	var _LocationContent = __webpack_require__(9);
	
	var _LocationContent2 = _interopRequireDefault(_LocationContent);
	
	var _LocationRelated = __webpack_require__(11);
	
	var _LocationRelated2 = _interopRequireDefault(_LocationRelated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WisconsinLocation = function (_React$Component) {
	  _inherits(WisconsinLocation, _React$Component);
	
	  function WisconsinLocation() {
	    _classCallCheck(this, WisconsinLocation);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  WisconsinLocation.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_HeroSmall2.default, { location: 'Wisconsin' }),
	      _react2.default.createElement(_LocationMicroNav2.default, null),
	      _react2.default.createElement(_LocationContent2.default, {
	        category: 'PlacesForBikes',
	        title: 'The First of Many',
	        story: 'At the first annual PlacesForBikes Conference in Madison, 275 leaders and thinkers gathered to focus on the challenges and opportunities of building better bicycle infrastructure\u2014fast. The conference centered on our four-part formula for building better PlacesForBikes: Engage, Plan, Build and Measure. City leaders from coast to coast networked, shared best practices and developed strong bonds. Trek provides lead sponsorship support for the PlacesForBikes program.'
	      }),
	      _react2.default.createElement(_gatsbyImage2.default, {
	        title: 'Wisconsin 1-1',
	        alt: 'First Annual PlacesForBikes Conference Photo',
	        sizes: this.props.data.wisconsinOneOneImage.sizes
	      }),
	      _react2.default.createElement(_LocationContent2.default, {
	        category: 'Promoting Ridership',
	        title: 'Goodbye, old friend',
	        story: 'In February, one of the founders of PeopleForBikes, Chris Kegel, passed away. Our senior staff attended a series of celebrations of his remarkable life, which included a group ride in Milwaukee that attracted more than 1,000 of his friends and family. Chris turned a single bike shop, Wheel & Sprocket, into one of the most successful family-owned bike store networks in the U.S. He was a tireless advocate who wanted everyone to experience the joy of a safe bike ride. According to PeopleForBikes president Tim Blumenthal, "Chris had a remarkable ability to see through complicated situations and to blend business and advocacy." PeopleForBikes is helping administer the Chris Kegel Foundation that is dedicated to improving lives through cycling.'
	      }),
	      _react2.default.createElement(_gatsbyImage2.default, {
	        title: 'Wisconsin 2-1',
	        alt: 'Chris Kegel',
	        sizes: this.props.data.wisconsinTwoOneImage.sizes
	      }),
	      _react2.default.createElement(_LocationRelated2.default, {
	        prevLocationName: 'Washington, DC',
	        prevLocationPath: 'washington-dc',
	        prevLocationImgPath: this.props.data.wisconsinPrevImage,
	        nextLocationName: 'Port Angeles, WA',
	        nextLocationPath: 'port-angeles',
	        nextLocationImgPath: this.props.data.wisconsinNextImage
	      })
	    );
	  };
	
	  return WisconsinLocation;
	}(_react2.default.Component);
	
	exports.default = WisconsinLocation;
	
	// GraphQL query
	
	var wisconsinImageQuery = exports.wisconsinImageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-wisconsin-js-49780b07932c15f865fc.js